import { tap, withLatestFrom } from 'rxjs';
import {
  action$,
  dispatchAction,
  extractPayload,
  ofType,
  withNamespace,
} from '@ardoq/rxbeach';
import { GetAdditionalRoutineArgs } from '../../types';
import { NodeModelTypes } from '../../utils/consts';
import {
  componentTreeSelectionChanged,
  selectionStartSet,
  selectionToggle,
} from '@ardoq/component-selection';
import { enterPressed, setIsSelectAll } from '@ardoq/dropdown-menu';

export const getContextSelectorSelectionRoutine = ({
  navigator$,
  navigatorConfiguration,
}: GetAdditionalRoutineArgs) =>
  action$.pipe(
    withNamespace(navigatorConfiguration.actionNamespace),
    ofType(enterPressed),
    extractPayload(),
    withLatestFrom(navigator$),
    tap(([{ nodeId, withMetaKey }, state]) => {
      const highlightedNode = state.tree.getNode(
        nodeId || state.tree.keyboardSelectedNodeId || ''
      );
      if (
        !highlightedNode ||
        !highlightedNode.isSelectable ||
        highlightedNode.isDisabledOption
      ) {
        return;
      }
      if (highlightedNode.type === NodeModelTypes.COMPONENT) {
        if (withMetaKey && !state.tree.getIsAllSelected()) {
          dispatchAction(
            selectionToggle({ nodeId: highlightedNode.id }),
            navigatorConfiguration.actionNamespace
          );
        } else {
          dispatchAction(
            componentTreeSelectionChanged({
              treeSelection: [highlightedNode.id],
            }),
            navigatorConfiguration.actionNamespace
          );
        }
        dispatchAction(
          selectionStartSet({ selectionStart: highlightedNode.id }),
          navigatorConfiguration.actionNamespace
        );
        dispatchAction(setIsSelectAll(false));
      }
    })
  );
